import React from 'react';

const Error = ({ text, noMargin }) => (
  <span
    className="form__error"
    style={{ marginTop: noMargin && '2px', fontWeight: 1 }}
  >
    {text}
  </span>
);

export default Error;
